import { View, ViewParameters } from './View';

export interface ViewManagerParameters {
  onViewChange?: (view: View) => void;
  initialView: ViewParameters;
}

export class ViewManager {
  onViewChange?: (view: View) => void;
  currentView: View;
  isReady: boolean;

  constructor(params: ViewManagerParameters) {
    this.onViewChange = params?.onViewChange;
    this.currentView = new View(params.initialView);
    this.isReady = false;
  }

  start(params?: ViewParameters) {
    if (params) {
      this.currentView.setRoute(params);
    }
    this.isReady = true;
  }

  stop() {
    this.isReady = false;
  }

  startNewView(params: ViewParameters) {
    this.currentView = new View(params);
    this.onViewChange?.(this.currentView);
  }
}
